export class WrongCredentialsError extends Error {
  constructor(message = 'Invalid email or password') {
    super(message)
    this.name = 'WrongCredentialsError'
    Object.setPrototypeOf(this, WrongCredentialsError.prototype)
  }
}
